import { extend } from 'flarum/extend';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Collapsible from '../components/Collapsible';
import CategoryItem from '../components/CategoryItem';
import tagLabel from 'flarum/tags/helpers/tagLabel';

dayjs.extend(relativeTime);

export default () => {
    app.initializers.add('tag-category-extension', () => {
        const CategoriesPage = flarum.extensions['askvortsov-categories'].default['components/CategoriesPage'];

        extend(CategoriesPage.prototype, 'oninit', function() {
            this.openedIndex = null;
        });

        extend(CategoriesPage.prototype, 'containerItems', function(items) {
            // Remove the default categories list, so we can iterate over the tags ourselves to manage opened state
            items.remove('categoriesList');
            
            const pinned = this.tags.filter((tag) => tag.position() !== null);
            const cloud = this.tags.filter((tag) => tag.position() === null);

            items.add(
                'categoriesList',
                <div className="CategoriesPage-content sideNavOffset">
                  <ol className="TagCategoryList">
                    {pinned.map((tag, idx) => {
                        this.tag = tag;
                        this.subCategories = this.tag.children().sort((a, b) => a.position() - b.position());

                    return (
                        <Collapsible
                            subs={this.subCategories.map((sub) => 
                                (
                                    <CategoryItem 
                                        title={sub.name()}
                                        description={sub.description()}
                                        link={`/t/${sub.slug()}`}
                                        terminalPost={getTerminalPost(sub)}
                                        stats={[
                                            {number: sub.discussionCount(), icon: 'fas fa-comments', label: 'discussions'},
                                            {number: sub.postCount(), icon: 'fas fa-comment', label: 'replies'},
                                        ]}
                                        className="SubCategory"
                                    />
                                )
                            )}
                            className=""
                            isOpen={this.openedIndex === idx}
                            onToggle={() => {
                                this.openedIndex = this.openedIndex === idx ? null : idx;
                            }}            
                        >
                            <CategoryItem 
                                isMainCategory={true}
                                title={this.tag.name()}
                                icon={this.tag.icon()}
                                description={this.tag.description()}
                                link={`/t/${this.tag.slug()}`}
                                terminalPost={getTerminalPost(this.tag)}
                                stats={[
                                    {number: this.tag.discussionCount(), icon: 'fas fa-comments', label: 'discussions'},
                                    {number: this.tag.postCount(), icon: 'fas fa-comment', label: 'replies'},
                                ]}
                                className="MainCategory"
                            />
                        </Collapsible>
                        );
                    })}
                  </ol>
          
                  {cloud.length ? <div className="TagCloud">{cloud.map((tag) => [tagLabel(tag, { link: true }), ' '])}</div> : ''}
                </div>,
                50
              );
        });
    });
}

const getTerminalPost = (tag) => {
    const lastPostedAt = tag.lastPostedAt();
    const lastPostedDiscussionId = tag.data.relationships.lastPostedDiscussion?.data.id ?? '';
    const userId = app.store.data.discussions[lastPostedDiscussionId]?.lastPostedUser().id();
    const username = convertToName(app.store.data.users[userId]?.displayName());

    return (userId) ? `${username} - replied ${dayjs(lastPostedAt).fromNow()}` : '';
};

const convertToName = (str) => {
    return str?.replace(/-/g, ' ').replace(/\d+/g, '').trim();
}